import React from "react";
import { useTranslation } from "@emisgroup/acp-application-intl";

export const EmptyExtract: React.FC = () => {
  const { t: translate } = useTranslation();
  return (
    <div className="ebt-empty-state">
      <label className="ebt-empty-state__message">
        {translate("Extract.NoExtractsAdded.Title")}
      </label>
      <p className="ebt-empty-state__desc">
        {translate("Extract.NoExtractsAdded.Description")}
      </p>
    </div>
  );
};
